<template>
    <div class="bg-main position-relative vh-100">
       <div class="d-flex vh-100">
           <section class="graph graph-left h-100">
                   <img src="@/assets/images/circle-left-top.png" alt="" class="graph__skills graph__skills-left-top">
                   <img src="@/assets/images/circle-left-bottom.png" alt="" class="graph__skills graph__skills-left-bottom">
           </section>
            <section class="graph graph-right h-100">
                   <img src="@/assets/images/circle-top.png" alt="" class="graph__skills graph__skills-top">
                   <img src="@/assets/images/circle-right.png" alt="" class="graph__skills graph__skills-bottom">
            </section>
        </div>
       <section class="auth-section ">
            <div class="container-fluid">
                <div class="position-absolute pt-3">
                  <!-- Languages -->
                  <LanguageSwitcher></LanguageSwitcher>
                </div>
                <div class="row align-items-center vh-100">
                    <div class="col-10 col-sm-8 col-md-7 col-xl-4 offset-1 offset-sm-2 offset-md-3 offset-xl-2 mr-auto text-center vh-100 ">
                       <div class="login-main">
                            <div class="login-body">
                                <img src="@/assets/images/logo-white.svg" alt="logo" class=" img-fluid logo mb-5 mt-8 mt-sm-5 pt-7 pt-lg-5 mb-auto">
                                <div class="login-content">
                                    <div>
                                        <div class="mb-2 ">
                                            <h1 class="text-white lt-4 heavy-uppercase">{{ $t('default.login.authorization') }}</h1>
                                        </div>
                                            <p class="text-white f-1 mb-5">{{ $t('default.login.sign-in') }}</p>
                                            <!-- Form start -->
                                            <form @submit.prevent="handleLogin" class="mb-3 mx-5 mx-lg-6 px-lg-2">
                                                <div class="mb-3">
                                                    <label for="forCode" class="visually-hidden">{{ $t('default.login.code') }}</label>
                                                    <input v-model="formData.code" type="text" class="form-control" id="forCode" :placeholder="$t('default.login.code')">
                                                </div>
                                                <div class="mb-3">
                                                    <label for="forPassword" class="visually-hidden">{{ $t('default.login.password') }}</label>
                                                    <input v-model="formData.password" type="password" class="form-control" id="forPassword" :placeholder="$t('default.login.password')">
                                                </div>
                                                <button class="btn btn-white-green mb-1 mt-5 mt-sm-3">{{ $t('default.login.login') }}</button>
                                            </form>
                                            <!-- form end -->
                                        <router-link to="/reset-password" class="text-white f-3 mt-4 pt-3 mt-sm-0 pt-sm-0">{{ $t('default.login.forgot-password') }}</router-link>
                                    </div>
                                </div>
                                <div class="login-footer pb-7  pb-lg-5 mx-5 px-md-5 px-xxl-2 w-xs-50 w-sm-50">
                                    <hr>
                                    <span class="text-white f-2">{{ $t('default.copyright') }} {{new Date().getFullYear()}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
       </section>
      <teleport to="body">
        <base-modal
          ref="modal"
          id="digipass"
          :title="$t('default.login.digipass.title')"
          :hide-footer="true"
          size="md">
          <template v-slot:body>
            <div class="row">
              <div class="col-12 mb-4">
                <div v-html="$t('default.login.digipass.instruction')"></div>
                <div class="input-group my-3">
                  <input v-model="formData.digipass" type="text" class="form-control" :placeholder="$t('default.login.digipass.enter-code')">
                  <div class="input-group-append">
                    <button :disabled="isDisabled"
                            @click="sendDigipass()"
                            class="btn btn-primary">{{ $t('default.login.digipass.get-code') }}</button>
                  </div>
                </div>
              </div>
              <div class="col-12 text-right">
                <button @click="checkDigipass" class="btn btn-success me-2" type="submit">
                  {{ $t('default.login.digipass.login') }}
                </button>
                <button @click="close" class="btn btn-secondary">{{ $t('default.close') }}</button>
              </div>
            </div>
          </template>
        </base-modal>
      </teleport>
   </div>
</template>
<script>
import UserResource from '../api/userResource'
import { mapGetters } from 'vuex'
import LanguageSwitcher from '@/components/core/LanguageSwitcher'
import BaseModal from '../components/shared/components/UI/BaseModal'
import moment from 'moment'

const userResource = new UserResource()

export default {
  name: 'Login',

  components: { LanguageSwitcher, BaseModal },

  computed: {
    ...mapGetters({
      user: 'auth/user',
      token: 'auth/token'
    }),

    now () {
      return moment()
    }
  },

  data () {
    return {
      formData: {
        code: '',
        password: '',
        digipass: ''
      },
      isDisabled: false
    }
  },

  methods: {
    checkDigipass () {
      if (!this.formData.digipass) {
        this.$helpers.notifyWarningMessage(this.$t('default.login.digipass.please-enter-digipass'),
          true,
          this.$t('default.close'))
        return
      }

      userResource.login(this.formData.code, this.formData.password, this.formData.digipass)
        .then(response => {
          this.setUserData(response.data.data.token, response.data.data.user)
          this.redirect()
        })
        .catch(error => {
          this.$helpers.notifyErrorMessage(error)
        })
    },

    handleLogin () {
      userResource.login(this.formData.code, this.formData.password)
        .then(response => {
          if (response.data.data.has_digipass) {
            this.$refs.modal.open()
          } else {
            this.setUserData(response.data.data.token, response.data.data.user)
            this.redirect()
          }
        })
        .catch(error => {
          this.$helpers.notifyErrorMessage(error)
        })
    },

    setUserData (token, data) {
      localStorage.setItem('token', token)
      this.$store.dispatch('auth/setUserData', data)
    },

    redirect () {
      window.location.href = '/'
    },

    close () {
      this.$refs.modal.close()
    },

    sendDigipass () {
      userResource.sendDigipass(this.formData.code, this.formData.password)
        .then(() => {
          this.isDisabled = true
          setTimeout(() => {
            this.isDisabled = false
          }, 1000 * 30)
        })
        .catch(error => {
          this.$helpers.notifyErrorMessage(error)
        })
    }
  }
}
</script>
